<div mat-dialog-content>
  <mat-toolbar color="primary" class="mat-elevation-z2 mb-15">
    @if (isReplace) {
      <mat-card-header class="msg-box-header">{{'sprint9.analyzer.upload.dialog-unsaveschanges.toggle.1.titel' | translate}}</mat-card-header>
    }
    @if (!isReplace) {
      <mat-card-header class="msg-box-header">{{'sprint9.analyzer.upload.dialog-unsaveschanges.toggle.2.titel' | translate}}</mat-card-header>
    }
  </mat-toolbar>
  @if (isReplace) {
    <p class="pt-15" [innerHTML]="'sprint9.analyzer.upload.dialog-unsaveschanges.content.2' | translate"></p>
  }
  @if (!isReplace) {
    <p class="pt-15" [innerHTML]="'sprint9.analyzer.upload.dialog-unsaveschanges.content.2' | translate"></p>
  }
  <p>
    <a class="ob-nav-link" (click)="exportDataSheet()">
      <mat-icon svgIcon="file_excel" class="ob-icon"></mat-icon>
      <span translate>i18n.result.download.exportAnalyse.excel-datei</span>
    </a>
  </p>
  @if (isReplace) {
    <p class="bold" translate>sprint9.analyzer.upload.dialog-unsaveschanges.content.toogle.1</p>
  }
  @if (!isReplace) {
    <p class="bold" translate>sprint9.analyzer.upload.dialog-unsaveschanges.content.toogle.2</p>
  }
</div>
<div mat-dialog-actions>
  <button mat-button obButton="primary" tabindex="0" (click)="onConfirm()" id="btnBksOderBstYes">{{'i18n.common.yes' | translate}}</button>
  <button mat-button obButton="secondary" (click)="onCancel()"  tabindex="0" id="btnBksOderBstNo">{{'i18n.common.no' | translate}}</button>
</div>
